<template>
  <div class="relative overflow-hidden from-primary to-pink-500 pt-20 md:pt-0">
    <div class="container mx-auto px-[40px]">
      <form @submit.prevent="submitForm" class="space-y-6">
        <!-- 两列布局：Name 和 Email -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label
              for="name"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Name <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="name"
              v-model="formData.name"
              :class="{ 'border-red-500': errors.name }"
              class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
            />
            <p v-if="errors.name" class="mt-1 text-sm text-red-600">
              {{ errors.name }}
            </p>
          </div>

          <div>
            <label
              for="address"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Email <span class="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              v-model="formData.email"
              :class="{ 'border-red-500': errors.email }"
              class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
            />
            <p v-if="errors.email" class="mt-1 text-sm text-red-600">
              {{ errors.email }}
            </p>
          </div>
        </div>

        <!-- 两列布局：Product Name 和 Subject -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label
              for="telephone"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Telephone
            </label>
            <input
              type="text"
              id="telephone"
              v-model="formData.telephone"
              :class="{ 'border-red-500': errors.telephone }"
              class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
            />
            <p v-if="errors.telephone" class="mt-1 text-sm text-red-600">
              {{ errors.telephone }}
            </p>
          </div>

          <div>
            <label
              for="company"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Company
            </label>
            <input
              type="text"
              id="company"
              v-model="formData.company"
              :class="{ 'border-red-500': errors.company }"
              class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
            />
            <p v-if="errors.company" class="mt-1 text-sm text-red-600">
              {{ errors.company }}
            </p>
          </div>
        </div>

        <div>
          <label
            for="shippingAddr"
            class="block text-sm font-medium text-gray-700 mb-1"
          >
            Shipping Address
          </label>
          <input
            type="text"
            id="shippingAddr"
            v-model="formData.shippingAddr"
            :class="{ 'border-red-500': errors.shippingAddr }"
            class="rounded-md w-full px-4 py-2.5 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
          />
          <p v-if="errors.shippingAddr" class="mt-1 text-sm text-red-600">
            {{ errors.shippingAddr }}
          </p>
        </div>

        <!-- =======================选中产品类目====================== -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
          <div
            v-for="(item, index) in showList"
            :key="'checkbox-' + index"
            class="flex items-start cursor-pointer group select-none"
            @click="toggleEvent(item)"
          >
            <div class="flex items-center h-7">
              <div
                class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
                :class="
                  isEventSelected(item)
                    ? 'border-red-600 bg-white'
                    : 'border-gray-300 bg-white'
                "
              >
                <svg
                  v-if="isEventSelected(item)"
                  class="w-3.5 h-3.5 text-red-600 animate-checkmark"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  stroke-width="4"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
            </div>
            <span class="ml-3 mt-0.5 text-[15px] text-[#555555] font-semibold">
              {{ item.label }}
            </span>
          </div>
        </div>

        <!-- 尺寸和重量 -->
        <div
          v-for="item in formData.categoryDetails"
          :key="item.name"
          class="bg-gray-50 p-4 rounded-md border border-gray-100 shadow-sm overflow-hidden"
        >
          <div class="flex items-center justify-between">
            <span
              class="text-xs font-black text-[#555555] uppercase tracking-widest"
              >{{ item.name }}</span
            >
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="space-y-1">
              <label class="text-[10px] font-bold text-gray-400 ml-1 uppercase"
                >Size <span class="text-red-500">*</span></label
              >
              <input
                v-model="item.size"
                type="text"
                placeholder=""
                :class="{
                  'border-red-500': errors.categoryDetails[item.key].size
                }"
                class="w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
              />
              <p v-if="errors.email" class="mt-1 text-sm text-red-600">
                {{ errors.categoryDetails[item.key].size }}
              </p>
            </div>
            <div class="space-y-1">
              <label class="text-[10px] font-bold text-gray-400 ml-1 uppercase"
                >Quantities <span class="text-red-500">*</span></label
              >
              <input
                v-model="item.quantities"
                type="number"
                placeholder=""
                :class="{
                  'border-red-500': errors.categoryDetails[item.key].quantities
                }"
                class="w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200"
              />
              <p v-if="errors.email" class="mt-1 text-sm text-red-600">
                {{ errors.categoryDetails[item.key].quantities }}
              </p>
            </div>
          </div>
        </div>

        <!-- message 信息 -->
        <div>
          <label
            for="message"
            class="block text-sm font-medium text-gray-700 mb-1"
          >
            Ideas for the design <span class="text-red-500">*</span>
          </label>
          <textarea
            id="message"
            v-model="formData.message"
            rows="6"
            :class="{ 'border-red-500': errors.message }"
            class="rounded-md w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:border-transparent transition duration-200 resize-y"
          ></textarea>
          <div class="flex justify-between mt-1">
            <p v-if="errors.message" class="text-sm text-red-600">
              {{ errors.message }}
            </p>
            <p class="text-sm text-gray-500 ml-auto">
              {{ formData.message.length }}/1000
            </p>
          </div>
        </div>

        <!-- 选择文件 -->
        <div>
          <label
            for="message"
            class="block text-sm font-medium text-gray-700 mb-1"
          >
            Upload your own design
          </label>
          <div
            class="border-2 border-dashed border-gray-300 rounded-md p-10 text-center bg-gray-50"
            @click="$refs.fileInput.click()"
            @dragover.prevent
            @drop.prevent="handleDrop"
          >
            <input
              type="file"
              ref="fileInput"
              class="hidden"
              accept=".jpg,.png,.pdf,.doc,.docx,.webp,.jpeg"
              multiple
              @change="handleFileChange"
            />
            <p class="text-sm text-gray-500">
              Drop files here or
              <span class="text-red-500 cursor-pointer font-bold"
                >Select files</span
              >
            </p>
            <p class="text-xs text-gray-400 mt-2">
              Accepted file types: jpg, png, pdf, doc, webp, jpeg. Max file
              size: 30 MB.
            </p>
          </div>
          <div v-if="selectedFiles.length > 0" class="space-y-1 mt-2">
            <div
              v-for="(file, i) in selectedFiles"
              :key="i"
              class="text-xs rounded-md bg-gray-50 p-2 flex justify-between border border-gray-200"
            >
              <span class="truncate">{{ file.name }}</span>
              <button
                @click.stop="removeFile(i)"
                class="text-red-500 px-2 font-bold"
              >
                ✕
              </button>
            </div>
          </div>
        </div>

        <!-- Submit 按钮 -->
        <div class="">
          <button
            type="submit"
            :disabled="loading"
            class="bg-[#d4335d] hover:bg-[#d4335d] text-white font-medium py-2 px-8 rounded-3xl focus:outline-none focus:ring-1 focus:ring-[#aeb1b5] focus:ring-offset-2 transition duration-200"
          >
            <span v-if="loading" class="loader"></span>
            <span v-else>Submit</span>
          </button>
        </div>

        <!-- 表单状态提示 -->
        <div
          v-if="submitStatus"
          class="mt-4 p-4 rounded-md"
          :class="
            submitStatus === 'success'
              ? 'bg-green-50 text-green-800'
              : 'bg-red-50 text-red-800'
          "
        >
          <div class="flex">
            <div class="flex-shrink-0">
              <svg
                v-if="submitStatus === 'success'"
                class="h-5 w-5 text-green-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                v-else
                class="h-5 w-5 text-red-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="ml-3">
              <p class="text-sm">
                {{
                  submitStatus === 'success'
                    ? 'Success. Thank you for your feedback.'
                    : 'Failed, please try again later.'
                }}
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExhibitionBookingForm',
  data() {
    return {
      loading: false,
      formData: {
        name: '',
        email: '',
        telephone: '',
        company: '',
        shippingAddr: '',
        categoryDetails: [],
        message: ''
      },
      showList: [
        {
          label: 'Keychain',
          key: 'keychain'
        },
        {
          label: 'Lapel Pin',
          key: 'lapelPin'
        },
        {
          label: 'Medal',
          key: 'medal'
        },
        {
          label: 'Challenge Coin',
          key: 'challengeCoin'
        },
        {
          label: 'Bottle Opener',
          key: 'bottleOpener'
        }
      ],
      selectedFiles: [],
      MAX_SIZE_MB: 30,
      isDragging: false,
      isUploading: false,
      uploadProgress: 0,
      submitStatus: '', // 'success' 或 'error'
      errors: {
        categoryDetails: {
          keychain: {
            size: '',
            quantities: ''
          },
          lapelPin: {
            size: '',
            quantities: ''
          },
          medal: {
            size: '',
            quantities: ''
          },
          challengeCoin: {
            size: '',
            quantities: ''
          },
          bottleOpener: {
            size: '',
            quantities: ''
          }
        }
      }
    }
  },
  methods: {
    resetErrors() {
      this.errors = {
        name: '',
        email: '',
        message: '',
        categoryDetails: {
          keychain: {
            size: '',
            quantities: ''
          },
          lapelPin: {
            size: '',
            quantities: ''
          },
          medal: {
            size: '',
            quantities: ''
          },
          challengeCoin: {
            size: '',
            quantities: ''
          },
          bottleOpener: {
            size: '',
            quantities: ''
          }
        }
      }
    },
    validateForm() {
      // 重置错误信息
      this.resetErrors()

      let isValid = true

      // 验证Name
      if (!this.formData.name.trim()) {
        this.errors.name = 'This field is required'
        isValid = false
      }

      // 验证Email
      if (!this.formData.email.trim()) {
        this.errors.email = 'This field is required'
        isValid = false
      } else if (!this.isValidEmail(this.formData.email)) {
        this.errors.email = 'Please enter a valid email address.'
        isValid = false
      }

      // 验证Product Name
      // if (!this.formData.productName.trim()) {
      //   this.errors.productName = 'This field is required'
      //   isValid = false
      // }

      // 验证Subject
      // if (!this.formData.subject.trim()) {
      //   this.errors.subject = 'This field is required'
      //   isValid = false
      // }
      if (this.formData.categoryDetails.length > 0) {
        for (let i = 0; i < this.formData.categoryDetails.length; i++) {
          if (!this.formData.categoryDetails[i].size) {
            let key = this.formData.categoryDetails[i].key
            this.errors.categoryDetails[key].size = 'This field is required'
            isValid = false
          }
          if (!this.formData.categoryDetails[i].quantities) {
            let key = this.formData.categoryDetails[i].key
            this.errors.categoryDetails[key].quantities =
              'This field is required'
            isValid = false
          }
        }
      }
      // this.errors = JSON.parse(JSON.stringify(this.errors))
      // console.log(
      //   '=================' + JSON.stringify(this.errors.categoryDetails)
      // )

      // 验证Message
      if (!this.formData.message.trim()) {
        this.errors.message = 'This field is required'
        isValid = false
      } else if (this.formData.message.length > 1000) {
        this.errors.message =
          'Der Inhalt der Nachricht darf 1000 Zeichen nicht überschreiten.'
        isValid = false
      }

      return isValid
    },
    submitForm() {
      if (this.validateForm()) {
        console.log(JSON.stringify(this.formData))
        // 模拟表单提交到服务器
        console.log('表单数据:', JSON.stringify(this.formData))

        // 1. 必须实例化
        const fd = new FormData()

        // 2. 处理 JSON 数据 (转换为 Blob 并指定 Content-Type)
        fd.append(
          'data',
          new Blob([JSON.stringify(this.formData)], {
            type: 'application/json'
          })
        )

        // 3. 处理多图片 (遍历 FileList)
        if (this.selectedFiles) {
          for (let i = 0; i < this.selectedFiles.length; i++) {
            fd.append('images', this.selectedFiles[i])
          }
        }
        this.loading = true
        this.$api.sysApi
          .sendEmailPro(fd)
          .then((res) => {
            this.submitStatus = 'success'
            this.loading = false
            setTimeout(() => {
              this.resetForm()
              this.submitStatus = ''
            }, 3000)
          })
          .catch((err) => {
            console.log(err)
            this.submitStatus = 'error'
            this.loading = false
            this.resetForm()
            setTimeout(() => {
              this.submitStatus = ''
            }, 2000)
          })
        //   // 显示成功消息
        //   this.submitStatus = 'success'

        //   // 3秒后重置表单和状态
        //   setTimeout(() => {
        //     this.resetForm()
        //     this.submitStatus = ''
        //   }, 3000)
        // } else {
        //   // 显示错误消息
        //   this.submitStatus = 'error'

        //   // 2秒后隐藏错误消息
        //   setTimeout(() => {
        //     this.submitStatus = ''
        //   }, 2000)
      }
    },
    isValidEmail(address) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(address)
    },
    toggleEvent(item) {
      const idx = this.formData.categoryDetails.findIndex(
        (i) => i.name === item.label
      )
      if (idx > -1) {
        this.formData.categoryDetails.splice(idx, 1)
      } else {
        this.formData.categoryDetails.push({
          name: item.label,
          key: item.key,
          size: '',
          quantities: null
        })
      }
    },
    isEventSelected(item) {
      return this.formData.categoryDetails.some((i) => i.name === item.label)
    },
    handleFileChange(e) {
      this.processFiles(Array.from(e.target.files))
      e.target.value = '' // 重置以允许重复选择同名文件
    },
    handleDrop(e) {
      this.isDragging = false
      this.processFiles(Array.from(e.dataTransfer.files))
    },
    processFiles(files) {
      const allowedExtensions =
        /(\.jpg|\.jpeg|\.png|\.pdf|\.doc|\.docx|\.webp)$/i
      const maxSize = this.MAX_SIZE_MB * 1024 * 1024

      files.forEach((file) => {
        if (!allowedExtensions.exec(file.name)) {
          alert(`File type not supported: ${file.name}`)
          return
        }
        if (file.size > maxSize) {
          alert(`File too large: ${file.name} (Max ${this.MAX_SIZE_MB}MB)`)
          return
        }
        this.selectedFiles.push(file)
      })
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1)
    },
    resetForm() {
      this.formData = {
        name: '',
        email: '',
        telephone: '',
        company: '',
        shippingAddr: '',
        categoryDetails: [],
        message: ''
      }
      this.selectedFiles = []
      this.resetErrors()
    }
  }
}
</script>

<style scoped>
/* 浮动标签控制 */
label {
  transition: opacity 0.2s;
}
.opacity-0 {
  opacity: 0;
  pointer-events: none;
}

/* Transition-group 动画定义 (Vue 2 标准) */
.staggered-list-enter-active,
.staggered-list-leave-active {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.staggered-list-enter {
  opacity: 0;
  transform: translateY(20px);
}

.staggered-list-leave-to {
  opacity: 0;
  transform: scale(0.95);
  position: absolute; /* 确保离开时列表平滑收缩 */
  width: 100%;
}

.staggered-list-move {
  transition: transform 0.4s;
}

/* 对号图标出现动画 */
@keyframes checkmarkIn {
  from {
    stroke-dashoffset: 100;
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    stroke-dashoffset: 0;
    opacity: 1;
    transform: scale(1);
  }
}
.animate-checkmark {
  animation: checkmarkIn 0.3s ease-out forwards;
}

/* 去除输入框默认样式 */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.cursor-pointer {
  -webkit-tap-highlight-color: transparent;
}

/* 旋转动画 */
.loader {
  width: 18px;
  height: 18px;
  border: 2px solid #ffffff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/startYourProject/project.vue